import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    indicatorCards: [],
    personInfo: {
      countryInDative: '',
      personFullName: '',
      items: [],
    },
    topRfSubjectsEvents: [],
    topRfSubjectsGrowthRate: [],
    eventsCountByTypes: [],
    agreementsCountByTypes: [],
  },
};
